import * as React from "react";

export const CartIcon: React.FC = () => {
  return (
    <svg
      width="16"
      height="15"
      viewBox="0 0 90 80"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2 6.46623e-05C0.8954 6.46623e-05 0 0.895495 0 2.00006C0 3.10463 0.8954 4.00006 2 4.00006H14.375L24.9062 53.8125C24.7988 54.952 25.8569 56.0575 27 56H77C78.0566 56.015 79.0285 55.0568 79.0285 54C79.0285 52.9433 78.0566 51.9851 77 52H28.625L26.9375 44.0001H81C81.8955 43.9901 82.7416 43.3113 82.9375 42.4376L89.9375 12.4376C90.1976 11.2768 89.1895 10.0086 88 10.0001H19.75L17.9688 1.56256C17.7706 0.678585 16.9059 -0.00766534 16 6.46623e-05H2ZM20.5938 14.0001H85.5L79.4062 40.0001H26.0938L20.5938 14.0001ZM37 62C32.0532 62 28 66.0531 28 71C28 75.9469 32.0532 80 37 80C41.9469 80 46 75.9469 46 71C46 66.0532 41.9469 62 37 62ZM67 62C62.0532 62 58 66.0531 58 71C58 75.9469 62.0532 80 67 80C71.9469 80 76 75.9469 76 71C76 66.0532 71.9469 62 67 62ZM37 66C39.7851 66 42 68.2149 42 71C42 73.7852 39.7851 76 37 76C34.215 76 32 73.7851 32 71C32 68.215 34.215 66 37 66ZM67 66C69.7851 66 72 68.2149 72 71C72 73.7852 69.7851 76 67 76C64.215 76 62 73.7851 62 71C62 68.215 64.215 66 67 66Z"
        fill="black"
      />
    </svg>
  );
};
